import React from 'react';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { GlobalHeaderBanner } from "./components/HeaderBanner";
import Home from "./pages/Home";
import About from "./pages/About";
import Academics from "./pages/Academics";
import Curriculum from "./pages/Curriculum";
import Calendar from "./pages/Calendar";
import Syllabus from "./pages/Syllabus";
import QuestionPapers from "./pages/QuestionPapers";
import HolidayHomework from "./pages/HolidayHomework";
import TimeTable from "./pages/TimeTable";
import Teachers from "./pages/Teachers";
import Gallery from "./pages/Gallery";
import Notices from "./pages/Notices";
import Sports from "./pages/Sports";
import Contact from "./pages/Contact";
import MandatoryDisclosure from './pages/MandatoryDisclosure';
import Committees from './pages/Committees';
import ExaminationSchedule from './pages/ExaminationSchedule';
import SupportStaff from './pages/SupportStaff';
import DynamicPage from "./pages/DynamicPage";
import Login from "./admin/Login";
import Dashboard from "./admin/Dashboard";

const ProtectedRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem('adminLoggedIn') === 'true';
  return isLoggedIn ? children : <Navigate to="/admin/login" />;
};

const NotFound = () => (
  <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center' }}>
    <div>
      <h1 style={{ fontSize: '100px', color: '#1a3a6b' }}>404</h1>
      <h2>Page Not Found</h2>
      <a href="/" style={{ display: 'inline-block', padding: '12px 30px', background: '#1a3a6b', color: 'white', textDecoration: 'none', borderRadius: '8px' }}>Return Home</a>
    </div>
  </div>
);

function Layout() {
  const location = useLocation();
  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <>
      {!isAdminPage && <Navbar />}
      {!isAdminPage && <GlobalHeaderBanner />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/academics" element={<Academics />} />
        <Route path="/curriculum" element={<Curriculum />} />
        <Route path="/calendar" element={<Calendar />} />
        <Route path="/syllabus" element={<Syllabus />} />
        <Route path="/question-papers" element={<QuestionPapers />} />
        <Route path="/holiday-homework" element={<HolidayHomework />} />
        <Route path="/time-table" element={<TimeTable />} />
        <Route path="/teachers" element={<Teachers />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/notices" element={<Notices />} />
        <Route path="/sports" element={<Sports />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/mandatory-disclosure" element={<MandatoryDisclosure />} />
        <Route path="/committees" element={<Committees />} />
        <Route path="/examination-schedule" element={<ExaminationSchedule />} />
        <Route path="/support-staff" element={<SupportStaff />} />
        <Route path="/page/:slug" element={<DynamicPage />} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin/*" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isAdminPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;